function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.01701 260.287C-17.13 209.247 66.4892 126.115 168.458 168.393C242.72 199.182 148.34 22.3556 279.575 25.6204C340.155 27.1272 409.757 49.3914 445.605 91.5156C486.598 139.685 488.648 210.757 472.092 253.669C436.56 345.763 495.995 455.876 286.682 455.876C245.373 455.876 66.138 470.834 82.9361 394.603C105.306 293.074 17.7338 297.566 3.01701 260.287Z",
  fill: "#4318BD"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M147.818 141.525H271.558C286.486 141.525 298.588 153.627 298.588 168.555V419.294C298.588 426.463 295.74 433.338 290.671 438.407C285.602 443.476 278.726 446.324 271.558 446.324H147.818C140.649 446.324 133.774 443.476 128.705 438.407C123.636 433.338 120.788 426.463 120.788 419.294V168.555C120.788 153.627 132.89 141.525 147.818 141.525Z",
  fill: "#56557E"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.175 180.443H293.198V407.407H126.175V180.443Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.689 436.366C215.534 436.366 220.273 431.628 220.273 425.783C220.273 419.938 215.534 415.199 209.689 415.199C203.844 415.199 199.105 419.938 199.105 425.783C199.105 431.628 203.844 436.366 209.689 436.366Z",
  fill: "#A1A8C5"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 160.235,
  y: 159.781,
  width: 98.9057,
  height: 4.61841,
  rx: 2.30921,
  fill: "#A1A8C5"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 130.544,
  y: 201.157,
  width: 157.951,
  height: 66.1356,
  rx: 11.15,
  fill: "#E5E8F5"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.818 209.248L203.363 235.631L169.924 224.184L130.544 253.522V262.682C130.544 263.998 131.066 265.26 131.997 266.19C132.927 267.121 134.189 267.644 135.505 267.644H283.535C286.274 267.643 288.495 265.422 288.495 262.682V233.132L243.818 209.248Z",
  fill: "#BBC0D6"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 150.245,
  y: 273.625,
  width: 69.3013,
  height: 7.38732,
  rx: 3.69366,
  fill: "#E5E8F5"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 150.245,
  y: 284.012,
  width: 117.144,
  height: 7.38732,
  rx: 3.69366,
  fill: "#E5E8F5"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.514 290.862C144.274 290.862 148.133 287.003 148.133 282.243C148.133 277.483 144.274 273.625 139.514 273.625C134.754 273.625 130.896 277.483 130.896 282.243C130.896 287.003 134.754 290.862 139.514 290.862Z",
  fill: "#E0F5FF"
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 130.544,
  y: 303.526,
  width: 157.951,
  height: 66.1356,
  rx: 11.15,
  fill: "#E5E8F5"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M175.22 311.617L215.675 338L247.948 323.395L288.494 355.892V365.052C288.494 366.368 287.972 367.63 287.041 368.56C286.111 369.491 284.849 370.013 283.534 370.013H135.505C134.189 370.013 132.927 369.491 131.997 368.56C131.066 367.63 130.544 366.368 130.544 365.052V335.501L175.22 311.617Z",
  fill: "#BBC0D6"
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 150.245,
  y: 375.993,
  width: 69.3013,
  height: 7.38732,
  rx: 3.69366,
  fill: "#E5E8F5"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 150.245,
  y: 386.381,
  width: 117.144,
  height: 7.38732,
  rx: 3.69366,
  fill: "#E5E8F5"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.514 393.231C144.274 393.231 148.133 389.372 148.133 384.612C148.133 379.852 144.274 375.993 139.514 375.993C134.754 375.993 130.896 379.852 130.896 384.612C130.896 389.372 134.754 393.231 139.514 393.231Z",
  fill: "#E5E8F5"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M251.989 140.941C250.101 143.126 224.81 142.805 193.307 136.643C161.804 130.481 136.11 124.079 137.214 118.432C138.071 114.055 165.478 108.896 196.981 115.058C228.484 121.221 254.449 138.095 251.989 140.941Z",
  fill: "#A55400"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M297.855 53.1532C285.748 65.6752 276.729 70.3803 262.428 70.8965C253.646 71.2135 253.636 30.6636 249.63 29.9289C244.237 28.9389 233.384 72.7048 206.497 67.4535C179.613 62.1877 186.049 17.558 180.682 16.4426C176.694 15.6143 158.46 51.5543 150.445 47.9517C137.392 42.0857 133.757 35.9471 127.259 19.7861C121.678 5.90302 109.06 -5.01571 125.158 35.7816C146.277 89.3038 138.986 113.443 138.606 115.387C138.392 116.496 138.737 117.449 138.976 118.493C140.085 123.325 141.881 105.875 199.616 115.626C249.702 124.087 246.925 143.31 250.403 139.74C251.269 138.852 251.079 138.689 251.324 137.438C251.704 135.493 254.046 110.386 293.774 68.7648C324.058 37.0367 308.255 42.3962 297.855 53.1532Z",
  fill: "#F8A441"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.048 120.655C140.502 120.448 139.498 120.857 140.294 120.553C140.979 120.292 141.662 120.031 142.356 119.791C144.902 118.923 147.494 118.194 150.12 117.608C159.505 115.554 169.127 114.794 178.718 115.35C200.091 116.421 222.287 122.745 240.374 134.387C243.523 136.414 246.432 138.36 249.057 140.97C251.092 142.991 254.237 139.845 252.203 137.824C249.851 135.606 247.303 133.606 244.59 131.85C237.497 127.111 229.885 123.201 221.902 120.197C199.928 111.69 175.21 108.208 151.932 112.69C147.154 113.609 142.256 114.793 137.804 116.813C135.2 117.995 137.46 121.83 140.05 120.655H140.048Z",
  fill: "#F57C00"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.181 106.338C145.595 105.013 149.127 104.013 152.73 103.353C162.147 101.491 171.767 100.859 181.347 101.473C202.867 102.648 225.264 108.797 243.646 120.271C244.987 121.109 246.305 121.982 247.6 122.89C248.16 123.284 248.712 123.689 249.26 124.096C249.417 124.212 250.199 124.81 249.564 124.322C248.94 123.84 249.637 124.379 249.785 124.499C250.55 125.117 251.324 125.731 252.031 126.416C256.148 130.4 262.448 124.113 258.324 120.123C255.825 117.827 253.123 115.76 250.252 113.951C242.893 109.063 234.83 105.267 226.58 102.149C203.706 93.5022 178.24 90.0066 154.024 94.0848C149.258 94.888 144.293 95.8839 139.809 97.757C137.594 98.6823 136.008 100.702 136.704 103.23C137.279 105.321 139.945 107.27 142.177 106.336L142.181 106.338Z",
  fill: "#F57C00"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M141.895 105.209C145.309 103.884 148.841 102.885 152.443 102.224C161.958 100.338 171.678 99.6926 181.359 100.305C203.069 101.49 225.673 107.679 244.219 119.256C245.561 120.093 246.879 120.966 248.174 121.875C248.733 122.267 249.286 122.669 249.834 123.08C249.951 123.167 250.631 123.687 250.251 123.393C249.871 123.1 250.479 123.572 250.584 123.658C251.349 124.276 252.123 124.889 252.83 125.574C255.918 128.562 260.643 123.849 257.549 120.855C255.12 118.623 252.494 116.616 249.702 114.858C242.424 110.023 234.456 106.253 226.296 103.169C203.622 94.5968 178.347 91.06 154.333 95.1038C149.568 95.907 144.604 96.903 140.119 98.7761C138.463 99.4674 137.258 100.989 137.789 102.881C138.227 104.447 140.214 105.913 141.894 105.211L141.895 105.209Z",
  fill: "#F7931E"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M179.708 25.1222C183.962 25.1222 187.41 21.6736 187.41 17.4195C187.41 13.1654 183.962 9.7168 179.708 9.7168C175.454 9.7168 172.005 13.1654 172.005 17.4195C172.005 21.6736 175.454 25.1222 179.708 25.1222Z",
  fill: "#F57C00"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118.51 15.4054C122.764 15.4054 126.213 11.9568 126.213 7.70271C126.213 3.44862 122.764 0 118.51 0C114.256 0 110.808 3.44862 110.808 7.70271C110.808 11.9568 114.256 15.4054 118.51 15.4054Z",
  fill: "#F57C00"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M249.454 37.1915C253.708 37.1915 257.156 33.7429 257.156 29.4888C257.156 25.2348 253.708 21.7861 249.454 21.7861C245.2 21.7861 241.751 25.2348 241.751 29.4888C241.751 33.7429 245.2 37.1915 249.454 37.1915Z",
  fill: "#F57C00"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M309.343 53.6325C313.597 53.6325 317.046 50.1838 317.046 45.9298C317.046 41.6757 313.597 38.2271 309.343 38.2271C305.089 38.2271 301.641 41.6757 301.641 45.9298C301.641 50.1838 305.089 53.6325 309.343 53.6325Z",
  fill: "#F57C00"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M211.473 141.798L233.809 141.988V131.528C233.809 128.745 232.703 126.075 230.735 124.107C228.767 122.139 226.097 121.033 223.314 121.033H211.475L211.473 141.798Z",
  fill: "#BBC0D6"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M191.42 374.572H91.9297V143.419L216.154 141.843V339.684C216.156 358.953 210.688 374.572 191.42 374.572Z",
  fill: "#8F97B9"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M187.913 374.572H88.4229V155.917C88.423 146.664 92.0989 137.79 98.642 131.247C105.185 124.704 114.059 121.029 123.312 121.029H222.802C222.802 121.029 212.651 121.42 212.651 142.38V339.684C212.649 358.952 207.181 374.572 187.913 374.572Z",
  fill: "#E5E8F5"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.446 374.554H74.6266C59.6929 374.554 58.6338 362.302 58.6338 347.189C58.6338 347.189 178.549 347.151 178.549 347.189C178.549 373.821 189.446 374.554 189.446 374.554Z",
  fill: "#BBC0D6"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.4633 224.733H199.408C201.687 224.733 203.535 226.581 203.535 228.861V266.329C203.535 268.608 201.687 270.456 199.408 270.456H98.4633C96.1838 270.456 94.3359 268.608 94.3359 266.329V228.861C94.3359 226.581 96.1838 224.733 98.4633 224.733Z",
  fill: "#BBC0D6"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M97.1471 276.456H143.324C144.877 276.456 146.135 277.715 146.135 279.267V318.356C146.135 319.909 144.877 321.168 143.324 321.168H97.1471C96.4015 321.168 95.6864 320.871 95.1591 320.344C94.6319 319.817 94.3358 319.102 94.3359 318.356V279.267C94.3362 277.714 95.5948 276.456 97.1471 276.456Z",
  fill: "#BBC0D6"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.484 281.927L118.216 299.763L107.25 292.025L94.335 311.859V318.052C94.335 319.904 95.0637 321.405 95.9622 321.405H144.508C145.407 321.405 146.135 319.906 146.135 318.052V298.073L131.484 281.927Z",
  fill: "white"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M154.531 276.456H200.708C202.261 276.456 203.519 277.715 203.519 279.267V318.356C203.519 319.909 202.261 321.168 200.708 321.168H154.531C153.785 321.168 153.07 320.871 152.543 320.344C152.016 319.817 151.72 319.102 151.72 318.356V279.267C151.72 277.714 152.979 276.456 154.531 276.456Z",
  fill: "#BBC0D6"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M188.868 281.927L175.601 299.763L164.634 292.025L151.72 311.859V318.052C151.72 319.904 152.448 321.405 153.347 321.405H201.893C202.791 321.405 203.52 319.906 203.52 318.052V298.073L188.868 281.927Z",
  fill: "white"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M127.534 154.021H170.338C171.749 154.021 172.892 155.164 172.892 156.575C172.892 157.985 171.749 159.128 170.338 159.128H127.534C126.124 159.128 124.98 157.985 124.98 156.575C124.98 155.164 126.124 154.021 127.534 154.021Z",
  fill: "#BBC0D6"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M110.995 161.579H186.875C188.285 161.579 189.429 162.722 189.429 164.132C189.429 165.543 188.285 166.686 186.875 166.686H110.995C109.585 166.686 108.441 165.543 108.441 164.132C108.441 162.722 109.585 161.579 110.995 161.579Z",
  fill: "#BBC0D6"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.422 179.491H197.302C198.712 179.491 199.856 180.635 199.856 182.045C199.856 183.455 198.712 184.599 197.302 184.599H121.422C120.011 184.599 118.868 183.455 118.868 182.045C118.868 180.635 120.011 179.491 121.422 179.491Z",
  fill: "#BBC0D6"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.422 191.395H197.302C198.712 191.395 199.856 192.538 199.856 193.949C199.856 195.359 198.712 196.502 197.302 196.502H121.422C120.011 196.502 118.868 195.359 118.868 193.949C118.868 192.538 120.011 191.395 121.422 191.395Z",
  fill: "#BBC0D6"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.6542 201.553H197.3C198.71 201.553 199.853 202.696 199.853 204.106C199.853 205.517 198.71 206.66 197.3 206.66H98.6542C97.2439 206.66 96.1006 205.517 96.1006 204.106C96.1006 202.696 97.2439 201.553 98.6542 201.553Z",
  fill: "#BBC0D6"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.6542 210.279H177.344C178.755 210.279 179.898 211.422 179.898 212.832C179.898 214.243 178.755 215.386 177.344 215.386H98.6542C97.2439 215.386 96.1006 214.243 96.1006 212.832C96.1006 211.422 97.2439 210.279 98.6542 210.279Z",
  fill: "#BBC0D6"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.6542 326.911H197.3C198.71 326.911 199.853 328.054 199.853 329.464C199.853 330.875 198.71 332.018 197.3 332.018H98.6542C97.2439 332.018 96.1006 330.875 96.1006 329.464C96.1006 328.054 97.2439 326.911 98.6542 326.911Z",
  fill: "#BBC0D6"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.6542 335.636H177.344C178.755 335.636 179.898 336.78 179.898 338.19C179.898 339.6 178.755 340.744 177.344 340.744H98.6542C97.2439 340.744 96.1006 339.6 96.1006 338.19C96.1006 336.78 97.2439 335.636 98.6542 335.636Z",
  fill: "#BBC0D6"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.678 179.614H111.111C112.247 179.614 113.337 180.065 114.14 180.868C114.943 181.672 115.395 182.761 115.395 183.898V192.869C115.395 195.235 113.477 197.153 111.111 197.153H100.678C98.3124 197.153 96.3945 195.235 96.3945 192.869V183.898C96.3945 181.532 98.3124 179.614 100.678 179.614Z",
  fill: "#BBC0D6"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M138.032 261.072V235.733L163.371 247.913L138.032 261.072Z",
  fill: "white"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M249.812 287.51C249.83 303.273 262.603 316.047 278.366 316.065C285.362 316.055 291.031 310.387 291.04 303.391V241.04C291.031 234.045 285.362 228.376 278.366 228.367H262.485C255.49 228.376 249.821 234.045 249.812 241.04V287.51ZM263.159 287.51V241.715L277.693 241.713V302.703C269.568 302.333 263.168 295.643 263.159 287.51Z",
  fill: "#F7931E"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.432 303.391C387.441 310.387 393.11 316.056 400.106 316.065C415.869 316.046 428.643 303.272 428.661 287.51V241.04C428.651 234.045 422.983 228.376 415.987 228.367H400.106C393.11 228.376 387.441 234.044 387.432 241.04V303.391ZM400.778 302.704V241.715H415.312V287.512C415.303 295.645 408.903 302.335 400.778 302.704Z",
  fill: "#F7931E"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M365.372 407.433H313.459L329.931 307.934H353.328L365.372 407.433Z",
  fill: "#F57C00"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M301.398 402.404H377.434C379.475 402.404 381.129 404.058 381.129 406.099V411.368C381.129 413.409 379.475 415.063 377.434 415.063H301.398C299.357 415.063 297.703 413.409 297.703 411.368V406.099C297.703 404.058 299.357 402.404 301.398 402.404Z",
  fill: "#F8A441"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M284.644 412.955H394.186C395.491 412.955 396.549 414.013 396.549 415.319V443.966C396.549 445.272 395.491 446.33 394.185 446.33H284.644C283.339 446.33 282.28 445.272 282.28 443.966V415.319C282.28 414.013 283.339 412.955 284.644 412.955Z",
  fill: "#725E4F"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M339.416 358.593C305.924 358.593 278.521 331.191 278.521 297.699V213.666H400.31V297.699C400.31 331.19 372.908 358.593 339.416 358.593Z",
  fill: "#F8A441"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M274.067 197.854H404.763C408.341 197.854 411.242 200.755 411.242 204.334V213.98C411.242 217.558 408.341 220.459 404.763 220.459H274.067C270.489 220.459 267.588 217.558 267.588 213.98V204.334C267.588 200.755 270.489 197.854 274.067 197.854Z",
  fill: "#F7931E"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M296.795 418.55H382.038V441.226H296.795V418.55Z",
  fill: "#8B7561"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M320.199 297.639H333.51L340.792 261.655H328.727L330.806 251.256C338.502 250.008 343.285 248.136 348.485 245.016H360.758L350.151 297.637H361.798L359.094 310.948H317.495L320.199 297.639Z",
  fill: "#FFE082"
});

var SvgAuthImage = function SvgAuthImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 482,
    height: 458,
    viewBox: "0 0 482 458",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAuthImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AuthImage.4a897e8a.svg";
export { ForwardRef as ReactComponent };